/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unsafe-finally */
/* eslint-disable block-scoped-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-cond-assign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-plusplus */
Object.defineProperty(exports, "__esModule", {
  value: true,
});

const _extends =
  Object.assign ||
  function(target) {
    for (let i = 1; i < arguments.length; i++) {
      const source = arguments[i];
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

const _slicedToArray = (function() {
  function sliceIterator(arr, i) {
    const _arr = [];
    let _n = true;
    let _d = false;
    let _e;
    try {
      for (
        var _i = arr[Symbol.iterator](), _s;
        !(_n = (_s = _i.next()).done);
        _n = true
      ) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i.return) _i.return();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    }
    if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    }
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
})();

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  return Array.from(arr);
}

function combineOrderedStyles(customMap, defaults) {
  if (customMap == null) {
    return defaults;
  }

  const _defaults = _slicedToArray(defaults, 2);

  const defaultStyleMap = _defaults[0];

  const defaultStyleOrder = _defaults[1];

  const styleMap = _extends({}, defaultStyleMap);
  const styleOrder = [].concat(_toConsumableArray(defaultStyleOrder));
  let _iteratorNormalCompletion = true;
  let _didIteratorError = false;
  let _iteratorError;

  try {
    for (
      var _iterator = Object.keys(customMap)[Symbol.iterator](), _step;
      !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
      _iteratorNormalCompletion = true
    ) {
      const _styleName = _step.value;

      if (defaultStyleMap.hasOwnProperty(_styleName)) {
        const defaultStyles = defaultStyleMap[_styleName];
        styleMap[_styleName] = _extends(
          {},
          defaultStyles,
          customMap[_styleName],
        );
      } else {
        styleMap[_styleName] = customMap[_styleName];
        styleOrder.push(_styleName);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [styleMap, styleOrder];
}

exports.default = combineOrderedStyles;



// WEBPACK FOOTER //
// ./src/components/CustomRevvEditor/helpers/combineOrderedStyles.js